import React from 'react';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import ResourceSummaryCard from 'Components/ComponentLibrary/Components/Uncategorized/ResourceSummaryCard';
import PageContentTop from 'Components/ComponentLibrary/Molecules/Page/PageContentTop';
import PageContentContainer from 'Components/ComponentLibrary/Molecules/Page/PageContentContainer';

const ApexFundingAccountUnlinkContent = () => {
  const { resource } = useMetaLayoutContext();

  return (
    <PageContentContainer>
      <PageContentTop
        badgeImage={resource.attr('badgeImage')}
        badgeImageAlt={resource.attr('badgeImageAlt')}
        title={resource.attr('title')}
        subtitle={resource.attr('subtitle')}
      />
      <ResourceSummaryCard resource={resource.attr('account').resources().head()} />
    </PageContentContainer>
  );
};

ApexFundingAccountUnlinkContent.propTypes = {
};

export default ApexFundingAccountUnlinkContent;
